(() => {
  function initialise(root) {
    root.querySelectorAll('[data-pp-birthday-form]').forEach(form => {
      if (form.dataset.ppReady) return;
      form.dataset.ppReady = 'true';
      const day = form.querySelector('[data-pp-day]');
      const month = form.querySelector('[data-pp-month]');
      if (!day || !month) return;
      const validate = () => {
        const d = Number(day.value), m = Number(month.value);
        const max = [0,31,29,31,30,31,30,31,31,30,31,30,31][m];
        day.setCustomValidity(d && m && d > max ? 'Choose a valid day for this month.' : '');
      };
      day.addEventListener('change', validate);
      month.addEventListener('change', validate);
      validate();
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
